import withStyles from "isomorphic-style-loader/withStyles";
import _ from "lodash";
import React from "react";
import { createRef } from "react";
import { FormattedMessage } from "react-intl";
import classes from './style.module.scss'

export const withScroll = Wrapped => {

    return withStyles(classes)(class extends React.Component {

        constructor(props) {
            super(props)
            this.state = {
                domRef: createRef()
            }
            this.scrollHandle = _.debounce(this.scrollHandle.bind(this), 100)
        }

        componentDidMount() {
            this.state.domRef?.current?.addEventListener('scroll', this.scrollHandle)
        }

        componentWillUnmount() {
            this.state.domRef?.current?.removeEventListener('scroll', this.scrollHandle)
        }

        scrollHandle(event) {
            const scrollTop = event.target.scrollTop,
                scrollHeight = event.target.scrollHeight,
                windowHeight = event.target.clientHeight
            if (scrollTop + windowHeight >= scrollHeight - 100 && !!!this.props.loading && !!!this.props.finished) {
                this.props?.request?.()
            }
        }

        render() {
            return <div style={{...this.props?.style}}>
                <Wrapped
                    innerRef={this.state.domRef}
                    {...this.props}
                    loadingDom={
                        <div className={classes.LoadingWrapper}>
                            {
                                this.props.loading && <div className={classes.Loading}><FormattedMessage id="loading" defaultMessage="Loading" /></div>
                            }
                            {
                                this.props.finished && <div className={classes.Finished}><FormattedMessage id="no_more_data" defaultMessage="No more data" />.</div>
                            }
                        </div>
                    }
                />
            </div>
        }
    })
}